module.exports = __webpack_public_path__ + "static/img/课程资源建设平台学生端1.2a6bc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/课程资源建设平台学生端1.png
// module id = etl9
// module chunks = 13